<template>
    <div class="border-gray-1000 bg-gray-1000 pt-3 xm:pt-0 px-1 xm:px-0 flex items-center flex-wrap xm:flex-no-wrap">
        <PlayButton :namespace="namespace" class="mx-2 flex-none" />
        <ReelScrubber :namespace="namespace" class="mx-1 order-first xm:order-none basis-100 xm:basis-auto xm:flex-1" />
        <TimeDisplay :namespace="namespace" class="mx-1 flex-none" />
        <VolumeIcon :namespace="namespace" class="mx-1 flex-none ml-auto xm:ml-1" />
        <VolumeSlider v-if="!isMobile" :namespace="namespace" class="mr-2 flex-none hidden xm:block" />
        <FullScreenButton :namespace="namespace" class="mx-2 flex-none" />
    </div>
</template>

<script>
    import TimeDisplay from './Controls/TimeDisplay'
    import PlayButton from './Controls/PlayButton'
    import FullScreenButton from './Controls/FullScreenButton'
    import VolumeSlider from './Controls/VolumeSlider'
    import VolumeIcon from './Controls/VolumeIcon'
    import ReelScrubber from './ReelScrubber'
    import detectMobile from '@/mixins/detectMobile'

    export default {
        mixins: [detectMobile],

        props: {
            namespace: { type: String, required: true },
        },

        components: {
            TimeDisplay,
            PlayButton,
            FullScreenButton,
            VolumeSlider,
            VolumeIcon,
            ReelScrubber,
        },
    }
</script>

<style scoped>
.border-gray-1000 {
  border-bottom: 0.01px solid rgba(255, 255, 255, 0.01);
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.01);
}
</style>
